class CompareDrawer extends HTMLElement {
  constructor() {
    super();

    const compareBanner = this;

    this.dialogRoot = this.querySelector('.compare-banner__wrapper');

    this.lastDrawerOpener = null;
    let compareCheckboxes = document.querySelectorAll('.product-compare-checkbox');

    const selectedCount = this.querySelector('.compare-banner__top-counter');
    this.compareBannerItems = this.querySelector('.compare-banner__product-items');
    let compareProductsList = JSON.parse(localStorage.getItem('compareProducts') || '[]');

    if (compareProductsList.length > 0) {
      compareBanner.classList.add('half-open');
      this.initialCheckboxState();
      this.controlCheckboxLimit();
      this.updateSelectedCount();
      this.renderCompareDrawer();
      this.setCompareHeight();
    }

    this.setupMutationObserver();

    this.toggleOpenButton = this.querySelector('.compare-banner__top-show-btn');
    this.toggleOpenButton.addEventListener('click', function(event) {
      compareBanner.lastDrawerOpener = event.currentTarget || document.activeElement;
      compareBanner.classList.add('half-open');
      compareBanner.classList.toggle('open');

      if (compareBanner.classList.contains('open')) {
        compareBanner.enableFocusTrap();
        if (typeof compareBanner.focusHideButton === 'function') {
          compareBanner.focusHideButton();
        }
      } else {
        compareBanner.disableFocusTrap();
      }

      compareBanner.setCompareHeight();
    });


    this.toggleCloseButton = this.querySelector('.compare-banner__top-hide-btn');
    this.toggleCloseButton.addEventListener('click', function() {
      compareBanner.disableFocusTrap();
      compareBanner.classList.remove('half-open');
      compareBanner.classList.remove('open');

      const opener =
        compareBanner.lastDrawerOpener ||
        compareBanner.toggleOpenButton ||
        compareBanner.querySelector('.compare-banner__top-show-btn');

      if (opener && typeof opener.focus === 'function') {
        opener.focus();
      }
    });

    this.toggleCloseButton.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.disableFocusTrap();
        compareBanner.classList.remove('half-open');
        compareBanner.classList.remove('open');

        const opener =
          compareBanner.lastDrawerOpener ||
          compareBanner.toggleOpenButton ||
          compareBanner.querySelector('.compare-banner__top-show-btn');

        if (opener && typeof opener.focus === 'function') {
          opener.focus();
        }
      }
    });

    const buttonClearCheckedItems = this.querySelector('.compare-banner__top-btn-compare-clear');
    buttonClearCheckedItems.addEventListener('click', () => {
      compareCheckboxes.forEach((checkbox) => {
        checkbox.checked = false;
        checkbox.disabled = false;
      });

      selectedCount.textContent = 0;
      localStorage.removeItem("compareProducts");
      compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
      this.clearLocalStorage();
      this.controlCheckboxLimit();
      this.renderCompareDrawer();
      compareBanner.disableFocusTrap();
      compareBanner.classList.remove('half-open');
      compareBanner.classList.remove('open');

      const opener =
        compareBanner.lastDrawerOpener ||
        compareBanner.toggleOpenButton ||
        compareBanner.querySelector('.compare-banner__top-show-btn');

      if (opener && typeof opener.focus === 'function') {
        opener.focus();
      }
    });

    // Initial setup of checkbox listeners
    this.addCheckboxListeners(compareCheckboxes);

    this.addEventListener('click', function(event) {
      if (event.target.classList.contains('remove-compare-product')) {

        const productId = event.target.getAttribute('data-product-id');
        const checkboxes = document.querySelectorAll(`.product-compare-checkbox[data-product-id="${productId}"]`);
        
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });
    
        this.removeFromLocalStorage(productId);
        this.updateSelectedCount();
        this.controlCheckboxLimit();
        this.renderCompareDrawer();
      }
    });

    // Keyboard support for removing product from drawer (Enter/Space)
    this.addEventListener('keydown', (event) => {
      if ((event.key === 'Enter' || event.key === ' ') && event.target.classList.contains('remove-compare-product')) {
        event.preventDefault();

        const productId = event.target.getAttribute('data-product-id');
        const checkboxes = document.querySelectorAll(`.product-compare-checkbox[data-product-id="${productId}"]`);
        
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });

        this.removeFromLocalStorage(productId);
        this.updateSelectedCount();
        this.controlCheckboxLimit();
        this.renderCompareDrawer();
      }
    });
  }

  enableFocusTrap() {
    if (!this.dialogRoot) {
      this.dialogRoot = this.querySelector('.compare-banner__wrapper') || this;
    }

    if (typeof trapFocus === 'function') {
      const elementToFocus =
        this.toggleCloseButton ||
        this.querySelector('.compare-banner__top-hide-btn') ||
        this.dialogRoot;

      trapFocus(this.dialogRoot, elementToFocus);
    }
  }

  disableFocusTrap() {
    if (!this.dialogRoot) return;
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.dialogRoot);
    }
  }

  setupMutationObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((addedNode) => {
            if (addedNode.nodeType === 1) {
              // Check for facet-filters-form changes (existing functionality)
              if (addedNode.classList.contains('collection')) {
                const compareCheckboxes = document.querySelectorAll('.product-compare-checkbox');
                this.addCheckboxListeners(compareCheckboxes);
                this.initialCheckboxState();
              }
              
              // Check for product-recommendations changes (new functionality)
              if (addedNode.tagName === 'PRODUCT-RECOMMENDATIONS' || 
                  addedNode.classList.contains('product-recommendations--loaded') ||
                  addedNode.querySelector('product-recommendations')) {
                this.handleProductRecommendationsUpdate(addedNode);
              }
              
              // Check for any new compare checkboxes in the added content
              const newCheckboxes = addedNode.querySelectorAll ? addedNode.querySelectorAll('.product-compare-checkbox') : [];
              if (newCheckboxes.length > 0) {
                this.addCheckboxListeners(newCheckboxes);
                this.initialCheckboxState();
              }
            }
          });
        }
        
        // Handle attribute changes (for product-recommendations--loaded class)
        if (mutation.type === 'attributes' && 
            mutation.attributeName === 'class' && 
            mutation.target.classList.contains('product-recommendations--loaded')) {
          this.handleProductRecommendationsUpdate(mutation.target);
        }
      });
    });

    const config = {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    };
    
    observer.observe(document.body, config);
  }

  handleProductRecommendationsUpdate(element) {
    // Find all compare checkboxes within the product-recommendations element
    const productRecommendations = element.tagName === 'PRODUCT-RECOMMENDATIONS' ? 
                                   element : 
                                   element.querySelector('product-recommendations');
    
    if (productRecommendations) {
      const recommendationCheckboxes = productRecommendations.querySelectorAll('.product-compare-checkbox');
      if (recommendationCheckboxes.length > 0) {
        this.addCheckboxListeners(recommendationCheckboxes);
        this.initialCheckboxState();
        this.controlCheckboxLimit();
      }
    }
  }

  addCheckboxListeners(compareCheckboxes) {
    compareCheckboxes.forEach((checkbox) => {
      // Remove existing listener to prevent duplicates
      checkbox.removeEventListener('change', checkbox._compareChangeHandler);
      
      // Create and store the handler function
      checkbox._compareChangeHandler = () => {
        const productID = checkbox.getAttribute('data-product-id');

        if (checkbox.checked) {
          this.updateLocalStorage(productID);
        } else {
          this.clearDublicates(checkbox);
          this.removeFromLocalStorage(productID);
        }

        this.updateSelectedCount();
        this.controlCheckboxLimit();
        this.renderCompareDrawer();

        if (this.compareProductCount > 0) {
          this.lastDrawerOpener = checkbox;
          this.classList.add('open');
          this.enableFocusTrap();
          if (typeof this.focusHideButton === 'function') {
            this.focusHideButton();
          }
        } else {
          this.disableFocusTrap();
        }
      };
      
      // Add the new listener
      checkbox.addEventListener('change', checkbox._compareChangeHandler);
    });
  }

  focusHideButton() {
    const hideBtn = this.toggleCloseButton || this.querySelector('.compare-banner__top-hide-btn');
    if (hideBtn && typeof hideBtn.focus === 'function') {
      requestAnimationFrame(() => {
        try {
          hideBtn.focus({ preventScroll: true });
        } catch (e) {
          hideBtn.focus();
        }
      });
    }
  }

  clearDublicates(checkbox) {
    const productId = checkbox.getAttribute('data-product-id');
    const checkboxes = document.querySelectorAll(`.product-compare-checkbox[data-product-id="${productId}"]`);
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
  }

  clearLocalStorage() {
    let compareProductsList = [];
    localStorage.setItem('compareProducts', JSON.stringify(compareProductsList));
    compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
  }

  removeFromLocalStorage(productID) {
    let compareProductsList = JSON.parse(localStorage.getItem('compareProducts'));
    compareProductsList = compareProductsList.filter(product => product.productId !== productID);
    localStorage.setItem('compareProducts', JSON.stringify(compareProductsList));
  }

  updateLocalStorage(productID) {

    let compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
    const checkedCheckbox = document.querySelector(`.product-compare-checkbox[data-product-id="${productID}"]`);

    const productId = checkedCheckbox.getAttribute('data-product-id');
    const url = checkedCheckbox.getAttribute('data-product-url');
    const productUrl = url.split('?')[0];

    if (!compareProductsList.some(product => product.productId === productID)) {
      compareProductsList.push({ productId, productUrl });
    }

    localStorage.setItem('compareProducts', JSON.stringify(compareProductsList));
    compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
  }

  updateSelectedCount() {
    const compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
    const selectedCount = document.querySelector('.compare-banner__top-counter');
    const compareButton = document.querySelector('.compare-banner__top-btn-compare');
    selectedCount.textContent = compareProductsList.length;
    if (compareProductsList.length >= 2){
      compareButton.classList.remove('disabled');
    } else {
      compareButton.classList.add('disabled');
    }
  }

  controlCheckboxLimit() {
    let compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
    const uniqueProductIds = new Set(compareProductsList.map(product => product.productId));
    const compareCheckboxes = document.querySelectorAll('.product-compare-checkbox');
  
    if (uniqueProductIds.size >= 4) {
      compareCheckboxes.forEach((checkbox) => {
        if (!checkbox.checked) {
          checkbox.classList.add('disabled');
          checkbox.setAttribute('disabled', '');
        }
      });
    } else {
      compareCheckboxes.forEach((checkbox) => {
        checkbox.classList.remove('disabled');
        checkbox.removeAttribute('disabled');
      });
    }
  }

  initialCheckboxState() {
    const compareProductsList = JSON.parse(localStorage.getItem('compareProducts'));
    if (compareProductsList == null) return;
    compareProductsList.forEach(product => {
      document.querySelectorAll(`.product-compare-checkbox[data-product-id="${product.productId}"]`).forEach((checkbox) => {
        checkbox.checked = true;
      });
    });
  }

  setCompareHeight() {
    let height = 0;
    height = this.offsetHeight;
    document.documentElement.style.setProperty("--compare-height", `${height}px`);
  }

  static getSelectedProducts() {
    return JSON.parse(localStorage.getItem('compareProducts')) || [];
  }

  static async getDrawerProducts(compareProducts) {
    const tempHtml = {};
    await Promise.all(
      compareProducts.map(async (product) => {
        await fetch(`${product.productUrl}?sections=compare-drawer-product`)
          .then((response) => response.text())
          .then((html) => {
            tempHtml[product.productId] = html;
          });
      })
    );

    const returnHtml = [];
    compareProducts.forEach((product) => returnHtml.push(tempHtml[product.productId]));
    return returnHtml;
  }
  
  async renderCompareDrawer() {
    const compareProducts = CompareDrawer.getSelectedProducts();
    const compareProductCount = compareProducts.length;
    const placeholdersNeeded = Math.max(0, 4 - compareProductCount);
    this.compareBannerItems.innerHTML = '';
		this.compareProductCount = compareProductCount;
  
    if (compareProductCount > 0) {
      const compareProductHtmlArr = await CompareDrawer.getDrawerProducts(compareProducts);
      compareProductHtmlArr.forEach((html) => {
        const htmlObj = JSON.parse(html);
        const htmlString = htmlObj["compare-drawer-product"];
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        const compareProductItem = tempDiv.querySelector('.compare-banner__product-item');
        if (compareProductItem) {
          this.compareBannerItems.appendChild(compareProductItem);
        }
      });
    }
  
    for (let i = 0; i < placeholdersNeeded; i++) {
      const placeholder = document.createElement('div');
      placeholder.classList.add('compare-banner__product-item');
      const placeholderText = document.querySelector('compare-modal .compare-modal-content')?.dataset.selectProduct || 'Select product to compare';
      placeholder.innerHTML = `<div class="compare-banner__product-item__empty-msg">${placeholderText}</div>`;
      this.compareBannerItems.appendChild(placeholder);
    }

		if (compareProductCount === 0) {
      const compareItems = document.querySelectorAll('compare-modal, compare-drawer');
			compareItems.forEach((item) => {
				item.classList.remove('open');
				item.classList.remove('half-open');
      });
      this.disableFocusTrap();
      document.body.classList.remove('overflow-hidden');
    }		

    this.initialCheckboxState();
  }
}

customElements.define('compare-drawer', CompareDrawer);


class CompareModal extends HTMLElement {
  constructor() {
    super();
    const compareModal = this;
    const compareBanner = document.querySelector('compare-drawer.compare-banner');
    let compareProductsList = JSON.parse(localStorage.getItem('compareProducts') || '[]');

    this.compareArea = compareModal.querySelector('.compare-modal-content');
    const showModalButton = document.querySelector('.compare-banner__top-btn-compare');
    const closeModal = document.querySelector('.compare-modal-close');
    const selectedCount = document.querySelector('.compare-banner__top-counter');

    this.focusTrapRoot = null;
    this.lastOpener = null;

    if (showModalButton) {
      showModalButton.addEventListener('click', function(event) {
        compareModal.lastOpener = event.currentTarget || document.activeElement;
        compareModal.classList.add('open');
        document.body.classList.add('overflow-hidden');
        compareModal.renderCompareTable();
        compareModal.enableFocusTrap();
        if (typeof compareModal.focusCloseButton === 'function') {
          compareModal.focusCloseButton();
        }
      });
    }

    if (showModalButton) {
      showModalButton.addEventListener('click', async (event) => {
        this.lastOpener = event.currentTarget || document.activeElement;

        compareModal.classList.add('open');
        document.body.classList.add('overflow-hidden');

        await compareModal.renderCompareTable();

        compareModal.enableFocusTrap();

        if (typeof compareModal.focusCloseButton === 'function') {
          compareModal.focusCloseButton();
        }
      });
    }

    if (closeModal) {
      closeModal.addEventListener('click', () => {
        compareModal.closeModal();
      });

      closeModal.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          compareModal.closeModal();
        }
      });
    }

    const clearProducts = this.querySelector('.clear-compare-modal-products');
    if (clearProducts) {
      clearProducts.addEventListener('click', () => {
        compareModal.classList.remove('open');
        document.body.classList.remove('overflow-hidden');
        this.disableFocusTrap();

        compareBanner.classList.remove('half-open');
        compareBanner.classList.remove('open');

        const compareCheckboxes = document.querySelectorAll('.product-compare-checkbox');
        compareCheckboxes.forEach((checkbox) => {
          checkbox.checked = false;
          checkbox.disabled = false;
        });

        selectedCount.textContent = 0;
        localStorage.removeItem("compareProducts");
        compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];

        this.clearLocalStorage();
        this.renderCompareDrawer();
        this.updateSelectedCount();
        this.controlCheckboxLimit();

        const showBtn = document.querySelector('.compare-banner__top-btn-compare');
        if (showBtn && typeof showBtn.focus === 'function') {
          showBtn.focus();
        }
      });
    }

    this.addEventListener('click', function(event) {
      if (event.target.classList.contains('remove-compare-product')) {

        const productId = event.target.getAttribute('data-product-id');
        const checkboxes = document.querySelectorAll(`.product-compare-checkbox[data-product-id="${productId}"]`);
        
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });

        const compareProducts = document.querySelectorAll('.compare-product-modal');
        compareProducts.forEach((product) => {
          if (product.getAttribute('data-product-id') == productId) {
            product.remove();
          } 
        });

        this.removeFromLocalStorage(productId);
        this.updateSelectedCount();
        this.controlCheckboxLimit();
        this.renderCompareDrawer();
      }
    })

    // Keyboard support for removing product from modal (Enter/Space)
    this.addEventListener('keydown', (event) => {
      if ((event.key === 'Enter' || event.key === ' ') && event.target.classList.contains('remove-compare-product')) {
        event.preventDefault();

        const productId = event.target.getAttribute('data-product-id');
        const checkboxes = document.querySelectorAll(`.product-compare-checkbox[data-product-id="${productId}"]`);
        
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });

        const compareProducts = document.querySelectorAll('.compare-product-modal');
        compareProducts.forEach((product) => {
          if (product.getAttribute('data-product-id') == productId) {
            product.remove();
          } 
        });

        this.removeFromLocalStorage(productId);
        this.updateSelectedCount();
        this.controlCheckboxLimit();
        this.renderCompareDrawer();
      }
    });

    if (this.classList.contains('open')) {
      this.enableFocusTrap();
      if (typeof this.focusCloseButton === 'function') {
        this.focusCloseButton();
      }
    }
  }


  closeModal() {
    this.classList.remove('open');
    document.body.classList.remove('overflow-hidden');
    this.disableFocusTrap();

    const showModalButton = document.querySelector('.compare-banner__top-btn-compare');
    const returnTarget = this.lastOpener || showModalButton;
    if (returnTarget && typeof returnTarget.focus === 'function') {
      returnTarget.focus();
    }
  }

  focusCloseButton() {
    const closeBtn = this.querySelector('.compare-modal-close');
    if (closeBtn && typeof closeBtn.focus === 'function') {
      requestAnimationFrame(() => {
        try {
          closeBtn.focus({ preventScroll: true });
        } catch (e) {
          closeBtn.focus();
        }
      });
    }
  }

  focusCloseButton() {
    const closeBtn = this.querySelector('.compare-modal-close');
    if (closeBtn && typeof closeBtn.focus === 'function') {
      requestAnimationFrame(() => {
        try {
          closeBtn.focus({ preventScroll: true });
        } catch (e) {
          closeBtn.focus();
        }
      });
    }
  }

  enableFocusTrap() {
    const root = this.querySelector('[data-focus-trap-root]') || this;
    this.focusTrapRoot = root;

    if (typeof trapFocus === 'function') {
      const focusTarget =
        this.querySelector('.compare-modal-close') ||
        this.querySelector('.clear-compare-modal-products') ||
        root;

      trapFocus(root, focusTarget);
    }
  }

  disableFocusTrap() {
    if (this.focusTrapRoot && typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.focusTrapRoot);
      this.focusTrapRoot = null;
    }
  }

  clearLocalStorage() {
    let compareProductsList = [];
    localStorage.setItem('compareProducts', JSON.stringify(compareProductsList));
    compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
  }

  removeFromLocalStorage(productID) {
    let compareProductsList = JSON.parse(localStorage.getItem('compareProducts'));
    compareProductsList = compareProductsList.filter(product => product.productId !== productID);
    localStorage.setItem('compareProducts', JSON.stringify(compareProductsList));
  }

  updateSelectedCount() {
    const compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
    const selectedCount = document.querySelector('.compare-banner__top-counter');
    const compareButton = document.querySelector('.compare-banner__top-btn-compare');
    selectedCount.textContent = compareProductsList.length;
    if (compareProductsList.length >= 2){
      compareButton.classList.remove('disabled');
    } else {
      compareButton.classList.add('disabled');
    }
  }

  controlCheckboxLimit() {
    let compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
    const uniqueProductIds = new Set(compareProductsList.map(product => product.productId));
    const compareCheckboxes = document.querySelectorAll('.product-compare-checkbox');
  
    if (uniqueProductIds.size >= 4) {
      compareCheckboxes.forEach((checkbox) => {
        if (!checkbox.checked) {
          checkbox.classList.add('disabled');
          checkbox.setAttribute('disabled', '');
        }
      });
    } else {
      compareCheckboxes.forEach((checkbox) => {
        checkbox.classList.remove('disabled');
        checkbox.removeAttribute('disabled');
      });
    }
  }

  static getSelectedProducts() {
    return JSON.parse(localStorage.getItem('compareProducts')) || [];
  }

  static async getModalProducts(compareProducts) {
    const tempHtml = [];
    await Promise.all(
      compareProducts.map(async (product) => {
        const response = await fetch(`${product.productUrl}`);
        if (response.ok) {
          const tmpl = document.createElement('template');
          tmpl.innerHTML = await response.text();
          
          const compareEl = tmpl.content.querySelector('.section-compare');
          if (compareEl) {
            tempHtml[product.productId] = compareEl.outerHTML;
          } 
        }
      })
    );

    const returnHtml = [];
    compareProducts.forEach((product) => returnHtml.push(tempHtml[product.productId]));
    return returnHtml;
  }

  async renderCompareTable() {
    const loadingSpinner = this.querySelector('.loading__spinner');
    loadingSpinner.classList.remove('hidden');
    this.compareArea.innerHTML = '';

    const compareProducts = CompareModal.getSelectedProducts();

    if (compareProducts) {

      this.compareArea.dataset.compareCount = compareProducts.length;

      const compareProductHtmlArr = await CompareModal.getModalProducts(compareProducts);
      const compareFieldsArr = [];

      if (compareProductHtmlArr.length > 0) {

        compareProductHtmlArr.forEach((compareProductHtml) => {


          const responseHTML = document.implementation.createHTMLDocument();
          responseHTML.documentElement.innerHTML = compareProductHtml;
          
          responseHTML.querySelectorAll('.shopify-section > div').forEach((compareField) => {
            
            if (!compareFieldsArr[compareField.dataset.compareKey]) {
              compareFieldsArr[compareField.dataset.compareKey] = [];
            }

            compareFieldsArr[compareField.dataset.compareKey].push(compareField);
          });
        });

        const compareElem = document.createElement('div');
        compareElem.className = 'compare-temp';

        Object.entries(compareFieldsArr).forEach(([key, value]) => {

          if (!value.every((elem) => !!elem.dataset.isEmptyMetafield)) {
            const compareRow = document.createElement('div');

            compareRow.className = `compare-row compare-row--${
              key.includes('metafield') ? 'metafield' : key.replace('compare-', '')
            }`;

            value.forEach((elem) => compareRow.appendChild(elem));
            compareElem.appendChild(compareRow);
          }
        });

        this.compareArea.innerHTML = compareElem.innerHTML;

      } else {
        this.compareArea.innerHTML = `Unable to compare products.${
          Shopify.designMode
            ? ' Ensure the Product Compare section is enabled.'
            : ' Please try again later.'
        }`;
      }

      setTimeout(() => {
        loadingSpinner.classList.add('hidden');
      }, 100);
    }
  }

  static async getDrawerProducts(compareProducts) {
    const tempHtml = {};
    await Promise.all(
      compareProducts.map(async (product) => {
        await fetch(`${product.productUrl}?sections=compare-drawer-product`)
          .then((response) => response.text())
          .then((html) => {
            tempHtml[product.productId] = html;
          });
      })
    );

    const returnHtml = [];
    compareProducts.forEach((product) => returnHtml.push(tempHtml[product.productId]));
    return returnHtml;
  }

  async renderCompareDrawer() {
    const compareProducts = CompareDrawer.getSelectedProducts();
    const compareProductCount = compareProducts.length;
    const placeholdersNeeded = Math.max(0, 4 - compareProductCount);
    const compareBannerItems = document.querySelector('.compare-banner__product-items');
    compareBannerItems.innerHTML = '';
		this.compareProductCount = compareProductCount;
  
    if (compareProductCount > 0) {
      const compareProductHtmlArr = await CompareDrawer.getDrawerProducts(compareProducts);
  
      compareProductHtmlArr.forEach((html) => {
        const htmlObj = JSON.parse(html);
        const htmlString = htmlObj["compare-drawer-product"];
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        const compareProductItem = tempDiv.querySelector('.compare-banner__product-item');
        compareBannerItems.appendChild(compareProductItem);
      });
    }
  
    for (let i = 0; i < placeholdersNeeded; i++) {
      const placeholder = document.createElement('div');
      placeholder.classList.add('compare-banner__product-item');
      const placeholderText = this.compareArea?.dataset.selectProduct || 'Select product to compare';
      placeholder.innerHTML = `<div class="compare-banner__product-item__empty-msg">${placeholderText}</div>`;
      compareBannerItems.appendChild(placeholder);
    }

    if (compareProductCount === 0) {
			const compareItems = document.querySelectorAll('compare-modal, compare-drawer');
			compareItems.forEach((item) => {
				item.classList.remove('open');
				item.classList.remove('half-open');
      });
      this.disableFocusTrap();
      document.body.classList.remove('overflow-hidden');
    }
  }

}

customElements.define('compare-modal', CompareModal);